import { TabsMap } from '@src/types';

/**
 * @author: dongjing
 * @file: description
 * @Date: 2020-01-06 14:29:02
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-04-09 18:35:48
 */
/**
 * @file
 *
 * @authors zhengmeiyu (zhengmeiyu@kuaishou.com)
 * @date    2019-08-22 14:07:08
 * @version 1.0.0
 */

export interface AvatarDropdownItem {
  title: string;
  key: string;
  path?: string;
}

export interface IOrderByItem {
  title: string;
  key: number;
}

export type IOrderByList = IOrderByItem & {
  children?: IOrderByItem[];
};

export const NETWORK_ERROR_TIP = '网络异常，请稍后重试';
export const TITLE = '磁力聚星';

export const UNDEFINED = void 0;
export const TO_YEWAR = new Date().getFullYear();

export const SEARCH_DEBOUNCE_DELAY = 300;

export const PAGE_SIZE = 10;
export const PAGE_NUM_ZERO = 0;
export const PAGE_TOTAL = 0;
export const THEMATIC_PAGE_SIZE = 6;

export const LIST_INITIAL = {
  list: [],
  loading: false,
  hasLoaded: false,
  isEnded: false,
  pageNum: PAGE_NUM_ZERO,
  total: PAGE_TOTAL
};

export const ILLEGAL_ARTICLE_ID = -1;
export const ILLEGAL_TAB_INDEX = '-1';

export const HOME_NAV_KEY = 'home';
export const ARTICLES_NAV_KEY = 'articles';
export const MESSAGE_NAV_KEY = 'message';
export const ASK_NAV_KEY = 'ask';
export const ANSWER_NAV_KEY = 'info';

export const TABS_MAP_ARTICLE = 'article';
export const TABS_MAP_ASK = 'ask';
export const TABS_MAP_ANSWER = 'answer';
export const TABS_MAP_VOTE = 'vote';
export const TABS_MAP_TOPIC = 'topic';

// 回答排序方式
export const ORDER_BY: IOrderByList[] = [
  {
    title: '默认排序',
    key: 0
  },
  {
    title: '按时间排序',
    key: 1
  }
];
/** 圈子，团队，标签tab */
export const TABS_MAP: TabsMap = {
  defaultActiveKey: TABS_MAP_ARTICLE,
  data: [
    { title: '文章', key: TABS_MAP_ARTICLE, index: '0' },
    { title: '提问', key: TABS_MAP_ASK, index: '1' },
    { title: '回答', key: TABS_MAP_ANSWER, index: '2' }
  ]
};
export const TABS_MAP_CIRCLE: TabsMap = {
  defaultActiveKey: TABS_MAP_ARTICLE,
  data: [
    { title: '文章', key: TABS_MAP_ARTICLE, index: '0' },
    { title: '提问', key: TABS_MAP_ASK, index: '1' },
    { title: '投票', key: TABS_MAP_VOTE, index: '2' },
    { title: '帖子', key: TABS_MAP_TOPIC, index: '3' }
  ]
};
